module.exports = __webpack_public_path__ + "assets/img/DB-Results-Service-Page-w960.169a7458.webp";